/**
 * Configuration for products that support daily aggregation view
 * Add product names to this array to enable Daily/Monthly toggle tabs
 */
export const DAILY_ENABLED_PRODUCTS = [
  "Microsoft Sentinel",
  "Defender for Containers",
  "Defender for App Services",
  "Defender for Servers",
  "Defender for Storage",
  "Defender Cloud Security Posture Management"
];

/**
 * Default aggregation type for all products
 */
export const DEFAULT_AGGREGATION_TYPE = "Monthly";
